import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TextBoxControl } from '../../../form-models/form-control-base';

@Component({
  selector: 'hb-df-textbox',
  templateUrl: './textbox.component.html',
})
export class TextboxComponent {
  @Input() control: TextBoxControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter<any>();
  @Output() paste = new EventEmitter<ClipboardEvent>();

  public onPaste(event: ClipboardEvent): void {
    this.paste.emit(event);
  }

  public overrideValue(): void {
    this.onOverrideValue.emit();
  }
}
